import { Typography, Box, useTheme, Button } from "@mui/material";
import { tokens } from "../theme";
import { useLoginModal } from "./LoginModalController";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useDisciplineFilter } from "./../DisciplineContext";
import { useCountryFilter } from "../CountryContext";

const Header = ({ auth, title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { openLogin } = useLoginModal();

  const { discipline, setDiscipline, options } = useDisciplineFilter();
  const { country, setCountry, options: countryOptions } = useCountryFilter();
  const handleButton = async () => {
    if (!auth.isAuthenticated) {
      openLogin();
    } else {
      await auth.logout();
    }
  };

  return (
    <Box >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography
            variant="h2"
            color={colors.primary[100]}
            fontWeight="bold"
            sx={{ m: 0 }}
          >
            {title}
          </Typography>

          <Typography variant="h5" color={colors.green[200]} sx={{ m: 0 }}>
            {subtitle}
          </Typography>
        </Box>

        <Button
          sx={{
            backgroundColor: colors.green[100],
            color: colors.primary[100],
            fontSize: "14px",
            fontWeight: "bold",
            padding: "10px 20px",
          }}
          onClick={handleButton}
        >
          {auth.isAuthenticated ? "Cerrar" : "Iniciar"}
        </Button>
      </Box>

      <hr />
      <Box mt="14px" display="flex" justifyContent="flex-start">
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel id="discipline-filter-label">Disciplina</InputLabel>
          <Select
            labelId="discipline-filter-label"
            value={discipline}
            label="Disciplina"
            onChange={(e) => setDiscipline(e.target.value)}
            sx={{
              backgroundColor: colors.primary[400],
              color: colors.primary[100],
              borderRadius: "10px",
            }}
          >
            {options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 220, ml: 2 }}>
          <InputLabel id="country-filter-label">País</InputLabel>
          <Select
            labelId="country-filter-label"
            value={country}
            label="País"
            onChange={(e) => setCountry(e.target.value)}
            sx={{
              backgroundColor: colors.primary[400],
              color: colors.primary[100],
              borderRadius: "10px",
            }}
          >
            {countryOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default Header;
